import styled from '@bd/bdui-styles/emotion';
import FilterBar from '@bd/bdui-filterbar';
import { colors } from '../styles';

export default styled(FilterBar)`
  position: relative;
  z-index: 1;
  .FilterBar_wrapper {
    width: 100%;
    border-top: 1px solid ${colors.color3};
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      border-bottom: 1px solid ${colors.color3};
    }
  }
  .FilterBar_list {
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: top;
    &:before {
      display: none;
      content: '';
      padding: 0 30px;
      height: 50px;
      background-image: url('/images/icon-filter-gray.svg');
      background-position: center center;
      background-repeat: no-repeat;
      border-right: 1px solid ${colors.color3};
      vertical-align: top;
      @media (min-width: 992px) {
        display: inline-block;
      }
    }
    .FilterBar_listItem {
      display: block;
      font-weight: 800;
      font-size: 16px;
      color: #3F3F3F;
      @media (min-width: 992px) {
        display: inline-block;
        vertical-align: top;
        border-right: 1px solid ${colors.color3};
      }
    }
  }
  .FilterSelect_title {
    padding: 0 30px 0 15px;
    cursor: pointer;
    line-height: 50px;
    display: block;
    background-color: #FFFFFF;
    background-image: url('/images/icon-triangle-gold.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
  }
  .FilterSelect_dropdown {
    position: relative;
    list-style: none;
    padding: 0 10px;
    background: #FFFFFF;
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
    background-color: ${colors.color3Lighter};
    @media (min-width: 992px) {
      position: absolute;
      width: auto;
      min-width: 200px;
    }
  }
  .FilterSelect_dropdownItem {
    font-weight: 300;
    font-size: 14px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    &:last-child {
      border: 0;
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .FilterSelect_dropdownItemButton {
    padding: 10px 0;
    display: inline-block;
    cursor: pointer;
    width: calc(100% - 30px);
  }
  .FilterSelect_dropdownItemCheckbox {
    display: inline-block;
    width: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/FilterBar.js